const companySizes = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '5001-10000',
  '10001+',
];

const companyRevenues = {
  '$0-$1m': '$0 - $1M',
  '$1m-$5m': '$1M - $5M',
  '$5m-$20m': '$5M - $20M',
  '$20m-$50m': '$20M - $50M',
  '$50m-$100m': '$50M - $100M',
  '$100m-$500m': '$100M - $500M',
  '$500m-$1b': '$500M - $1B',
  '$1b-$5b': '$1B - $5B',
  '$5b-$10b': '$5B - $10B',
  '$10b+': '$10B+',
};
const departments = {
  csuite: 'C-Suite',
  engineering_technical: 'Engineering & Technical',
  design: 'Design',
  education: 'Education',
  finance: 'Finance',
  human_resources: 'Human Resources',
  information_technology: 'Information Technology (IT)',
  legal: 'Legal',
  marketing: 'Marketing',
  medical_health: 'Medical & Health',
  operations: 'Operations',
  sales: 'Sales',
  consulting: 'Consulting',
  customer_success_support: 'Customer Success & Support',
};
const fundingTypes = {
  angel: 'Angel',
  seed: 'Seed',
  series_a: 'Series A',
  series_b: 'Series B',
  series_c: 'Series C',
  series_d: 'Series D',
  series_e: 'Series E',
  series_f: 'Series F',
  series_g: 'Series G',
  series_h: 'Series H',
  convertible_note: 'Convertible Note',
  corporate_round: 'Corporate Round',
  debt_financing: 'Debt Financing',
  equity_crowdfunding: 'Equity Crowdfunding',
  grant: 'Grant',
  initial_coin_offering: 'Initial Coin Offering',
  non_equity_assistance: 'Non-Equity Assistance',
  post_ipo_debt: 'Post IPO Debt',
  post_ipo_equity: 'Post IPO Equity',
  post_ipo_secondary: 'Post IPO Secondary',
  pre_seed: 'Pre Seed',
  private_equity: 'Private Equity',
  product_crowdfunding: 'Product Crowdfunding',
  secondary_market: 'Secondary Market',
  series_unknown: 'Series Unknown',
  undisclosed: 'Undisclosed',
};

const companyTypes = {
  EDUCATIONAL_INSTITUTION: 'Educational',
  GOVERNMENT_AGENCY: 'Government Agency',
  NONPROFIT: 'Non Profit',
  PARTNERSHIP: 'Partnership',
  PRIVATELY_HELD: 'Privately Held',
  PUBLIC_COMPANY: 'Public Company',
  'SELF-EMPLOYED': 'Self Employed',
  SOLE_PROPRIETORSHIP: 'Sole Proprietorship',
};

const companySizeMap = {
  '1-10': 5,
  '11-50': 30,
  '51-200': 125,
  '201-500': 350,
  '501-1000': 750,
  '1001-5000': 3000,
  '5001-10000': 7500,
  '10001+': 15000,
  '-': 0,
};

const fundingAmount = {
  100000: '0.1M',
  500000: '0.5M',
  1000000: '1M',
  5000000: '5M',
  10000000: '10M',
  25000000: '25M',
  50000000: '50M',
  100000000: '100M',
  500000000: '500M',
  1000000000: '1B',
};

const countries = [
  'afghanistan',
  'albania',
  'algeria',
  'andorra',
  'angola',
  'antigua and barbuda',
  'argentina',
  'armenia',
  'australia',
  'austria',
  'azerbaijan',
  'bahrain',
  'bangladesh',
  'barbados',
  'belarus',
  'belgium',
  'belize',
  'benin',
  'bhutan',
  'bolivia',
  'bosnia and herzegovina',
  'botswana',
  'brazil',
  'brunei',
  'bulgaria',
  'burkina faso',
  'burundi',
  'cabo verde',
  'cambodia',
  'cameroon',
  'canada',
  'central african republic',
  'chad',
  'chile',
  'china',
  'colombia',
  'comoros',
  'congo, democratic republic of the',
  'congo, republic of the',
  'costa rica',
  'croatia',
  'cuba',
  'cyprus',
  'czech republic',
  'denmark',
  'djibouti',
  'dominica',
  'dominican republic',
  'east timor (timor-leste)',
  'ecuador',
  'egypt',
  'el salvador',
  'equatorial guinea',
  'eritrea',
  'estonia',
  'eswatini',
  'ethiopia',
  'fiji',
  'finland',
  'france',
  'gabon',
  'georgia',
  'germany',
  'ghana',
  'greece',
  'grenada',
  'guatemala',
  'guinea',
  'guinea-bissau',
  'guyana',
  'haiti',
  'honduras',
  'hungary',
  'iceland',
  'india',
  'indonesia',
  'iran',
  'iraq',
  'ireland',
  'israel',
  'italy',
  'jamaica',
  'japan',
  'jordan',
  'kazakhstan',
  'kenya',
  'kiribati',
  'korea, north',
  'korea, south',
  'kosovo',
  'kuwait',
  'kyrgyzstan',
  'laos',
  'latvia',
  'lebanon',
  'lesotho',
  'liberia',
  'libya',
  'liechtenstein',
  'lithuania',
  'luxembourg',
  'madagascar',
  'malawi',
  'malaysia',
  'maldives',
  'mali',
  'malta',
  'marshall islands',
  'mauritania',
  'mauritius',
  'mexico',
  'micronesia, federated states of',
  'moldova',
  'monaco',
  'mongolia',
  'montenegro',
  'morocco',
  'mozambique',
  'myanmar (burma)',
  'namibia',
  'nauru',
  'nepal',
  'netherlands',
  'new zealand',
  'nicaragua',
  'niger',
  'nigeria',
  'north macedonia',
  'norway',
  'oman',
  'pakistan',
  'palau',
  'panama',
  'papua new guinea',
  'paraguay',
  'peru',
  'philippines',
  'poland',
  'portugal',
  'qatar',
  'romania',
  'russia',
  'rwanda',
  'saint kitts and nevis',
  'saint lucia',
  'saint vincent and the grenadines',
  'samoa',
  'san marino',
  'sao tome and principe',
  'saudi arabia',
  'senegal',
  'serbia',
  'seychelles',
  'sierra leone',
  'singapore',
  'slovakia',
  'slovenia',
  'solomon islands',
  'somalia',
  'south africa',
  'spain',
  'sri lanka',
  'sudan',
  'sudan, south',
  'suriname',
  'sweden',
  'switzerland',
  'syria',
  'taiwan',
  'tajikistan',
  'tanzania',
  'thailand',
  'the bahamas',
  'the gambia',
  'togo',
  'tonga',
  'trinidad and tobago',
  'tunisia',
  'turkey',
  'turkmenistan',
  'tuvalu',
  'uganda',
  'ukraine',
  'united arab emirates',
  'united kingdom',
  'united states',
  'uruguay',
  'uzbekistan',
  'vanuatu',
  'vatican city',
  'venezuela',
  'vietnam',
  'yemen',
  'zambia',
  'zimbabwe',
];

const seniorityLevels = ['Executive', 'Director & VP', 'Mid-level', 'Entry'];

const industries = [
  'accounting',
  'airlines and aviation',
  'alternative dispute resolution',
  'alternative medicine',
  'animation',
  'apparel and fashion',
  'architecture and planning',
  'armed forces',
  'automation machinery manufacturing',
  'automotive',
  'aviation & aerospace',
  'banking',
  'beverage manufacturing',
  'biotechnology',
  'biotechnology research',
  'broadcast media',
  'building materials',
  'business skills training',
  'business supplies and equipment',
  'capital markets',
  'chemical manufacturing',
  'chemicals',
  'civic and social organization',
  'civil engineering',
  'commercial real estate',
  'computer and network security',
  'computer games',
  'computer hardware',
  'computer hardware manufacturing',
  'computer networking',
  'computer networking products',
  'computer software',
  'construction',
  'consumer electronics',
  'consumer goods',
  'consumer services',
  'cosmetics',
  'dairy',
  'dairy product manufacturing',
  'defense and space',
  'design',
  'design services',
  'e-learning',
  'e-learning providers',
  'education administration programs',
  'education management',
  'electrical/electronic manufacturing',
  'entertainment',
  'entertainment providers',
  'environmental services',
  'events services',
  'executive office',
  'facilities services',
  'farming',
  'financial services',
  'fine art',
  'fishery',
  'food & beverages',
  'food production',
  'fund-raising',
  'furniture',
  'gambling and casinos',
  'glass, ceramics and concrete',
  'government administration',
  'government relations',
  'government relations services',
  'graphic design',
  'higher education',
  'hospital and health care',
  'hospitality',
  'human resources',
  'human resources services',
  'individual and family services',
  'industrial automation',
  'industrial automation machinery',
  'industrial machinery',
  'industrial machinery manufacturing',
  'information services',
  'insurance',
  'international affairs',
  'international trade and development',
  'internet',
  'internet publishing',
  'investment banking',
  'investment management',
  'judiciary',
  'law enforcement',
  'law practice',
  'leasing real estate',
  'legal services',
  'leisure, travel and tourism',
  'libraries',
  'logistics and supply chain',
  'luxury goods and jewelry',
  'machinery',
  'machinery manufacturing',
  'management consulting',
  'manufacturing',
  'maritime',
  'maritime transportation',
  'market research',
  'marketing services',
  'mechanical engineering',
  'media production',
  'medical devices',
  'medical equipment',
  'medical equipment manufacturing',
  'medical practices',
  'mental health care',
  'military',
  'mining',
  'mining and metals',
  'motor vehicle manufacturing',
  'music',
  'musicians',
  'nanotechnology',
  'nanotechnology research',
  'newspaper publishing',
  'newspapers',
  'non-profit organization management',
  'oil and energy',
  'online media',
  'outsourcing/offshoring',
  'package and freight delivery',
  'paper and forest products',
  'performing arts',
  'performing arts companies',
  'personal care product manufacturing',
  'pharmaceutical manufacturing',
  'pharmaceuticals',
  'philanthropic fundraising services',
  'philanthropy',
  'photography',
  'plastics',
  'plastics manufacturing',
  'political organizations',
  'primary and secondary education',
  'printing',
  'printing services',
  'professional training & coaching',
  'program development',
  'public policy',
  'public policy offices',
  'public safety',
  'publishing',
  'railroad manufacturing',
  'ranching',
  'real estate',
  'recreational facilities',
  'recruiting',
  'religious institutions',
  'renewable energy semiconductor manufacturing',
  'renewables and environment',
  'research',
  'research services',
  'restaurants',
  'retail',
  'retail art supplies',
  'retail groceries',
  'retail office equipment',
  'semiconductor manufacturing',
  'semiconductors',
  'shipbuilding',
  'software development',
  'spectator sports',
  'sporting goods',
  'sporting goods manufacturing',
  'sports',
  'strategic management services',
  'supermarkets',
  'telecommunications',
  'textile manufacturing',
  'textiles',
  'think tanks',
  'tobacco',
  'transportation/trucking/railroad',
  'travel arrangements',
  'truck transportation',
  'utilities',
  'venture capital and private equity',
  'veterinary',
  'veterinary services',
  'warehousing',
  'wholesale',
  'wholesale building materials',
  'wireless',
  'wireless services',
  'writing and editing',
];

const languages = [
  'africaans',
  'afrikaans',
  'albanian',
  'american Sign Language',
  'amharic',
  'anglais',
  'arabic',
  'arabic (tourist, rusty)',
  'aramaic',
  'armenian',
  'assamese',
  'aymara',
  'azerbaijani',
  'bahasa Indonesia',
  'balochi',
  'bamanankan',
  'basque',
  'belarusan',
  'belarusian',
  'bengali',
  'bhojpuri',
  'bislama',
  'bosnian',
  'brahui',
  'bulgarian',
  'burmese',
  'cantonese',
  'catalan',
  'català',
  'cebuano',
  'chechen',
  'cherokee',
  'chinese',
  'chinese',
  'chinese (Simplified)',
  'chinois',
  'circassian (Адыгэбзэ)',
  'croatian',
  'czech',
  'dakota',
  'danish',
  'dari',
  'dholuo',
  'dutch',
  'engels',
  'english',
  'espagnol',
  'español',
  'esperanto',
  'estonian',
  'farsi',
  'filipino',
  'finnish',
  'fluent English. Spoken and written',
  'français',
  'french',
  'french (rusty)',
  'galician',
  'georgian',
  'german',
  'german',
  'german (tourist, rusty)',
  'gikuyu',
  'greek',
  'guarani',
  'gujarati',
  'haitian creole',
  'hausa',
  'hawaiian',
  'hawaiian creole',
  'hebreeuws',
  'hebrew',
  'hiligaynon',
  'hindi',
  'hindi',
  'hindi, Tamil',
  'hungarian',
  'icelandic',
  'igbo',
  'ilocano',
  'indonesian',
  'ingles',
  'inglés',
  'irish gaelic',
  'ital',
  'italian',
  'japanese',
  'japonais',
  'jarai',
  'javanese',
  'kabyle',
  'kannada',
  'kashmiri',
  'kazakh',
  'khmer',
  'khoekhoe',
  'konkani',
  'korean',
  'kurdish',
  'kyrgyz',
  'k’iche’',
  'lao',
  'latin',
  'latvian',
  'lingala',
  'lithuanian',
  'macedonian',
  'maithili',
  'malagasy',
  'malay',
  'malayalam',
  'mandarin',
  'mandarin Chinese',
  'marathi',
  'marwari',
  'mende',
  'mongolian',
  'nahuatl',
  'navajo',
  'nederlands',
  'nepali',
  'norwegian',
  'ojibwa',
  'oriya',
  'oromo',
  'pashto',
  'persian',
  'polish',
  'portugese',
  'portuguese',
  'portugués',
  'punjabi',
  'quechua',
  'romani',
  'romanian',
  'russe',
  'russian',
  'russian (Русский)',
  'rwanda',
  'samoan',
  'sanskrit',
  'serbian',
  'shona',
  'sindhi',
  'sinhala',
  'sinhalese',
  'slovak',
  'slovene',
  'slovenian',
  'somali',
  'spanish',
  'swahili',
  'swedish',
  'tachelhit',
  'tagalog',
  'taiwanese',
  'tajiki',
  'tamil',
  'tatar',
  'telugu',
  'thai',
  'tigrigna',
  'tok pisin',
  'turkish',
  'turkmen',
  'ukrainean',
  'ukrainian',
  'ukranian',
  'urdu',
  'urdu',
  'urdu/hindi',
  'uyghur',
  'uzbek',
  'vietnamese',
  'warlpiri',
  'welsh',
  'wolof',
  'xhosa',
  'yakut',
  'yiddish',
  'yoruba',
  'yucatec',
  'zapotec',
  'zulu',
  'éwé',
  'Английский',
];

const subscriptionPlanLevels = { FREE: 1, PROFESSIONAL: 2, GROWTH: 3, SCALE: 4, ENTERPRISE: 5 };

export {
  languages,
  industries,
  seniorityLevels,
  companySizes,
  countries,
  fundingTypes,
  fundingAmount,
  companyRevenues,
  departments,
  companySizeMap,
  companyTypes,
  subscriptionPlanLevels,
};
